import React from 'react';
import Helmet from 'react-helmet';
import { Watch } from 'scrollmonitor-react';
import Happy from 'react-icons/lib/io/android-happy';

import Animated from '../Animated';
import AnimationWrapper from '../AnimationWrapper';

import { Caption } from './styles';
import {
  textContainer,
  removeMarginTop,
  shadowless,
  center,
} from '../../styles';

class JobDescription extends React.Component {
  render() {
    const { isInViewport } = this.props;

    return (
      <div {...textContainer}>
        <Helmet
          title="Role Profile | lucastswick"
          description="lucastswick does a pretty great job at EasyKicks"
        />
        <AnimationWrapper
          inProp={isInViewport}
          transitionName="slideUp"
          delay={100}
          once
        >
          <Caption>EasyKicks Role Profile</Caption>
        </AnimationWrapper>
        <AnimationWrapper
          inProp={isInViewport}
          transitionName="slideUp"
          delay={150}
          once
        >
          <h1 {...removeMarginTop}>Front-End Engineering Director</h1>
        </AnimationWrapper>

        <Animated as="h2">Responsibilities</Animated>
        <Animated>
          The Front-End Engineering Director is responsible for:
        </Animated>
        <Animated as="ol">
          <li>
            <b>Leadership</b>: Sets vision, motivates, and guides the team
            towards goals
          </li>
          <li>
            <b>Product Integrity</b>: Ensure the digital product exceeds
            experience expectations
          </li>
          <li>
            <b>Foster Talent</b>: Nurture the team's skills
          </li>
          <li>
            <b>Solve Problems</b>: Efficiently navigate any ambiguity
          </li>
        </Animated>

        <Animated as="h2">
          Essential Function of the Front-End Engineering Director
        </Animated>
        <Animated>The Front-End Engineering Director will:</Animated>
        <Animated as="ol">
          <li>
            Use <b>compassion</b> and empathy to create a welcoming culture
          </li>
          <li>
            <b>Energize</b> the team with an unending supply of support and
            enthusiasm
          </li>
          <li>
            <b>Listen</b> closely to diffuse friction or resolve concerns
          </li>
          <li>
            Be an unwavering <b>example</b> of tolerance and understanding
          </li>
          <li>
            <b>Define</b> expectations of how great a platform can be
          </li>
          <li>
            Push the experience by asking 'what if' and <b>implementing</b>{' '}
            solutions
          </li>
          <li>
            <b>Create</b> an enjoyable process that ensures best possible output
          </li>
          <li>
            <b>Communicate</b> clearly to reduce friction between varying levels
            of technical understanding
          </li>
          <li>
            Create cross-company <b>collaboration</b> and sharing within Valiant
            Labs
          </li>
          <li>
            <b>Manage</b> technical debt
          </li>
        </Animated>

        <Animated as="h2">Competencies</Animated>
        <Animated as="ul">
          <li>Strong architecture and programming skills</li>
          <li>Good understanding of server-side technologies</li>
          <li>Strong tolerance for ambiguity</li>
          <li>Strong leadership identity</li>
          <li>Effective communicator</li>
          <li>Creative problem solver</li>
          <li>Maintain nimble nature during shifting priorities</li>
          <li>
            Strong ability to move along gradient from high level strategy to
            local details
          </li>
          <li>
            Excels at thinking holistically while implementing solutions locally
          </li>
          <li>Measured optimist</li>
        </Animated>

        <Animated as="h2">Values</Animated>
        <Animated as="ul">
          <li>Inclusive environments</li>
          <li>Safe spaces</li>
          <li>Community and relationships</li>
          <li>A clean code base pruned like an english garden</li>
        </Animated>

        <Animated as="h2">Supervisory Responsibilities</Animated>
        <Animated>
          I manage engineers who develop the EasyKicks digital experience while
          actively contributing to the code base.
        </Animated>
        <Animated>
          The Front-End Engineering Director is also responsible for: training a
          diverse set of employees; planning, assigning and directing work;
          appraising performance; managing the code base.
        </Animated>

        <Animated as="h2">Required Experience</Animated>
        <Animated as="ol">
          <li>
            10+ recent years of practical engineering experience for the web and
            mobile
          </li>
          <li>5+ years in various management leadership roles</li>
        </Animated>

        <Animated as="h2">Candidate: Lucas Swick</Animated>

        <Animated as="h2">Background</Animated>
        <Animated as="ol">
          <li>15+ years engineering digital experiences</li>
          <li>10+ years empowering teams</li>
          <li>Expert at modern JS technologies including react and threejs</li>
          <li>
            Engineered Generative Art installations running in New York,
            Portland, and Raleigh
          </li>
          <li>
            Awarded a Generative Artist Residency with North Carolina State
            University in 2018.
          </li>
        </Animated>

        <Animated as="h2">Employment and Roles</Animated>
        <Animated as="ol">
          <li>Alberta Department of Eduction - Engineer</li>
          <li>Montage Studios - Engineer</li>
          <li>Summit Projects - Flash Team Lead</li>
          <li>
            <a
              {...shadowless}
              href="https://whoisowenjones.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              Owen Jones and Partners
            </a>{' '}
            - Technical Director
          </li>
          <li>
            <a
              {...shadowless}
              href="https://weareparliament.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              Parliament, Inc
            </a>{' '}
            - Technical Director
          </li>
          <li>
            <a
              {...shadowless}
              href="https://www.easykicks.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              EasyKicks
            </a>{' '}
            - Front-end Engineering Director
          </li>
          <li>
            <a
              {...shadowless}
              href="https://generativeartist.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              lucastswick
            </a>{' '}
            - Generative Artist
          </li>
        </Animated>

        <Animated as="h2">Superpowers</Animated>
        <Animated as="ol">
          <li>Canadian with US Green Card</li>
          <li>
            Installation Artist applying generative art to large immersive
            experiences
          </li>
          <li>Woodworker currently renovating a 1947 English farmhouse</li>
          <li>Photographer with 500k+ views</li>
          <li>Musician</li>
        </Animated>

        <Animated as="h2">Development opportunities</Animated>
        <Animated as="ul">
          <li>Conference budget for more exposure to upcoming solutions</li>
          <li>
            Create a Valiant labs maker space to explore physical and digital
            interactions
          </li>
          <li>
            Capitalize on opportunity for cross-company collaboration at Valiant
            Labs
          </li>
          <li>
            Pursuing speaking events in 2019 to discuss the importance of art
            and the humanities in software engineering teams.
          </li>
        </Animated>

        <div {...center}>
          <Animated as="div">
            <Happy color="#F772D7" size={90} />
          </Animated>
        </div>
      </div>
    );
  }
}

JobDescription.defaultProps = {
  theme: { colors: ['#fff', '#333', '#444'] },
};
export default Watch(JobDescription);



// WEBPACK FOOTER //
// ./src/components/JobDescription/JobDescription.js